var map = {
	"./cake.webp": 2352,
	"./correct-ico.webp": 2353,
	"./crown-blue.webp": 2354,
	"./crown.webp": 2355,
	"./pocket.webp": 2356,
	"./present.webp": 2357,
	"./relegation.webp": 2358,
	"./t-deposit.webp": 2359,
	"./t-turnover.webp": 2360,
	"./vip-1.webp": 2361,
	"./vip-2.webp": 2362,
	"./vip-3.webp": 2363,
	"./vip-4.webp": 2364,
	"./vip-5.webp": 2365,
	"./vip-badge.webp": 2366,
	"./vip-bg.webp": 2367,
	"./vip2.webp": 2368,
	"./vip3.webp": 2369,
	"./vip4.webp": 2370,
	"./vip5.webp": 2371,
	"./vip6.webp": 2372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;